import NotificationsNoneOutlined from '@mui/icons-material/NotificationsNoneOutlined'
import { Badge, IconButton, useTheme } from '@mui/material'
import {
  CourierInboxListItemActionFactoryProps,
  CourierInboxListItemFactoryProps,
  CourierInboxMenuButtonFactoryProps,
  CourierInboxPopupMenu,
  CourierToast,
} from '@trycourier/courier-react'
import React, { useCallback } from 'react'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'

// Full browser nav (not an SPA push) so Courier's cross-origin click-tracking redirect resolves.
const navigateTo = (href: string | undefined) => {
  if (!href) {
    return
  }
  const url = new URL(href, window.location.origin)
  if (url.protocol === 'http:' || url.protocol === 'https:') {
    window.location.assign(url.href)
  }
}

export const NotificationInbox: React.FC = () => {
  const userData = useAuthenticatedUser()
  const { palette } = useTheme()

  // Courier renders the trigger in a detached root with no theme context, so pass resolved literals.
  const renderMenuButton = useCallback(
    (props: CourierInboxMenuButtonFactoryProps | null | undefined) => (
      <IconButton sx={{ color: palette.fg.muted, p: 0 }}>
        <Badge
          variant="dot"
          invisible={!props?.totalUnreadCount}
          sx={{ '& .MuiBadge-dot': { bgcolor: palette.green[500], outline: `2px solid ${palette.common.white}` } }}
        >
          <NotificationsNoneOutlined sx={{ width: 23, height: 23 }} />
        </Badge>
      </IconButton>
    ),
    [palette]
  )

  const handleMessageClick = useCallback(
    ({ message }: CourierInboxListItemFactoryProps) => navigateTo(message.actions?.find((action) => action.href)?.href),
    []
  )
  const handleActionClick = useCallback(({ action }: CourierInboxListItemActionFactoryProps) => navigateTo(action.href), [])

  if (userData.isFullyAuthenticated && !userData.user.isSupplier) {
    return (
      <CourierInboxPopupMenu
        mode="light"
        popupAlignment="top-right"
        renderMenuButton={renderMenuButton}
        onMessageClick={handleMessageClick}
        onMessageActionClick={handleActionClick}
      />
    )
  }
  return null
}

export const NotificationToast: React.FC = () => {
  const userData = useAuthenticatedUser()
  if (userData.isFullyAuthenticated && !userData.user.isSupplier) {
    return <CourierToast mode="light" autoDismiss autoDismissTimeoutMs={5000} />
  }
  return null
}
